function bindAjaxCartForms() {
    document.querySelectorAll('[data-ajax-cart]').forEach((form) => {
        if (form.dataset.ajaxCartBound === 'true') return;
        form.dataset.ajaxCartBound = 'true';

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const formData = new FormData(form);
            const addButton = form.querySelector('[type="submit"]');
            const quantityInput = form.querySelector('input[name="quantity"]');
            const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

            const variantId =
                quantityInput?.dataset.variantId ||
                form.querySelector('input[name="id"]')?.value;

            let declaredMax = parseInt(quantityInput?.dataset.max, 10);
            const maxQty = declaredMax > 50 ? 50 : declaredMax;

            if (!variantId) {
                console.warn('No variant ID found in form.');
                return;
            }

            addButton.disabled = true;

            try {
                const cartRes = await fetch('/cart.js');
                const cartData = await cartRes.json();

                const existingItem = cartData.items.find(
                    (item) => item.variant_id == variantId
                );
                const currentQtyInCart = existingItem ? existingItem.quantity : 0;
                const totalAfterAdd = currentQtyInCart + quantity;

                if (totalAfterAdd > maxQty) {
                    const remaining = maxQty - currentQtyInCart;
                    showAddToCartMessage(
                        remaining > 0
                            ? `Only ${remaining} more pieces available. You already have ${currentQtyInCart} in cart.`
                            : `You already have the maximum stock allowed in your cart.`,
                        true
                    );
                    addButton.disabled = false;
                    return;
                }

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        Accept: 'application/json',
                    },
                });

                if (!response.ok) throw new Error('Add to cart failed');

                const data = await response.json();

                showAddToCartMessage(`✔ Added ${quantity} × "${data.title}" to cart`);

                const sectionsRes = await fetch(
                    '/?sections=cart-icon-bubble,cart-notification'
                );
                const sections = await sectionsRes.json();

                const cartBubble = document.querySelector('#cart-icon-bubble');
                if (cartBubble && sections['cart-icon-bubble']) {
                    cartBubble.innerHTML = sections['cart-icon-bubble'];
                    cartBubble.classList.add('animate');
                }

                const cartNotification = document.querySelector('#cart-notification');
                if (cartNotification && sections['cart-notification']) {
                    cartNotification.innerHTML = sections['cart-notification'];
                    cartNotification.classList.add('active');
                    setTimeout(() => {
                        cartNotification.classList.remove('active');
                    }, 3000);
                }

                bindAjaxCartForms();
            } catch (error) {
                console.error('Error adding to cart:', error);
                showAddToCartMessage(
                    '⚠ Failed to add product. Please try again.',
                    true
                );
            } finally {
                addButton.disabled = false;
            }
        });
    });
}

function showAddToCartMessage(message, isError = false) {
    const msg = document.createElement('div');
    msg.className = `ajax-cart-msg${isError ? ' error' : ''}`;
    msg.innerText = message;
    document.body.appendChild(msg);

    setTimeout(() => {
        msg.classList.add('show');
    }, 50);

    setTimeout(() => {
        msg.classList.remove('show');
        msg.addEventListener('transitionend', () => msg.remove(), {
            once: true,
        });
    }, 3000);
}

document.addEventListener('DOMContentLoaded', () => {
    bindAjaxCartForms();

    const observer = new MutationObserver(() => {
        bindAjaxCartForms();
    });
    observer.observe(document.body, { childList: true, subtree: true });
});
